import { Space, Typography } from 'antd'
import { Organisation } from '../../services/ApiContext'
import { FFEDocument } from '../../types/ffe'
import { calculateDocumentTotals } from '../../utils/calculations'
import { PrintHeader } from './PrintHeader'
import { PrintLineItems } from './PrintLineItems'
import { formatCurrency } from '../../utils/currency'
import { PrintFloorPlans } from './PrintFloorPlans'
import { countryTaxSystems } from '../../utils/tax/systems'

export interface Props {
  specification: FFEDocument
  organisation: Organisation
}
export const PrintedDocumentLayout = ({
  specification,
  organisation
}: Props) => {
  const totals = calculateDocumentTotals(
    specification.lineItems,
    specification.groups,
    specification.settings,
    organisation,
    specification.materials
  )

  const taxSystem =
  countryTaxSystems.find(
    (system) => system.taxSystem.countryCode === organisation.country
  ) || countryTaxSystems[0]


  return (
    <div className="p-12 max-w-[1200px] mx-auto">
      <PrintHeader organisation={organisation} />

      <Space direction="vertical" className="w-full ">
        <Typography.Text className="text-xl font-bold">
          {specification.projectTitle ?? 'FF&E Specification'}
        </Typography.Text>

        {specification.projectDescription && (
          <div
            className="ql-editor prose max-w-none text-gray-600"
            dangerouslySetInnerHTML={{
              __html: specification.projectDescription
            }}
          />
        )}
      </Space>

      <PrintLineItems document={specification} />

      {specification.footerContent && (
        <Space direction="vertical" className="w-full mt-8 mb-4">
          <div className="cursor-pointer min-h-[40px]">
            <div
              className="ql-editor prose max-w-none text-gray-600"
              dangerouslySetInnerHTML={{ __html: specification.footerContent }}
            />
          </div>
        </Space>
      )}

      {specification.settings.showClientPrices &&
        specification.settings.showTotalValue && (
          <div className="mt-8 flex justify-end">
            <div className="w-[300px]">
              <div className="flex justify-between py-1">
                <Typography.Text>Subtotal:</Typography.Text>
                <Typography.Text>
                  {formatCurrency(totals.subtotal)}
                </Typography.Text>
              </div>

              {!specification.settings.taxInclusive && (
                <div className="flex justify-between py-1">
                  <Typography.Text>
                    {taxSystem.taxSystem.abbreviation} ({organisation.taxRate}%):
                  </Typography.Text>
                  <Typography.Text>
                    {formatCurrency(totals.tax)}
                  </Typography.Text>
                </div>
              )}

              <div className="flex justify-between py-1 border-t font-semibold">
                <Typography.Text>Total:</Typography.Text>
                <Typography.Text>
                  {formatCurrency(totals.total)}
                </Typography.Text>
              </div>

              {specification.settings.taxInclusive && (
                <Typography.Text type="secondary" className="text-sm">
                  * Prices include {organisation.taxRate}% tax
                </Typography.Text>
              )}
            </div>
          </div>
        )}

      <PrintFloorPlans document={specification} />
    </div>
  )
}
